import { useSelector } from 'react-redux';
import { colors, Tabs } from '@sweep-io/sweep-design';
import { useState } from 'react';
import Alerts from '../../alerts/Alerts';
import {
  ConfigurationCanvasLeftPanel,
  ConfigurationCanvasPanelContent,
  ConfigurationCanvasPanelHeader,
} from '../configuration-canvas-panel';
import ScheduledReports from '../../alerts/ScheduledReports';
import { MultipleRuleBuildersProvider } from '../../common/sweep-condition-rule-builder/MultipleRuleBuildersContext';
import {
  selectSlackIntegrationStatus,
  selectSlackUpgradeStatus,
  SlackConnectionStatus,
} from '../../../reducers/integrationsReducer';
import { useIntegrations } from '../../../hooks/useIntegrations';
import { useRunOnce } from '../../common/useRunOnce';
import { Stack, Box } from '@mui/material';
import { useGetSidePadding } from '../configuration-canvas-panel/useGetSidePadding';
import { useExpandedMode } from '../configuration-canvas/panels-reserve-space/useExpandedMode';
import { GlobalRenderer } from '../global-renderer/GlobalRenderer';

enum AlertsDialogTabTypes {
  ALERTS = 'Alerts',
  SCHEDULED_REPORTS = 'Scheduled reports',
}

export const AlertsPage = () => {
  const [activeTab, setActiveTab] = useState(AlertsDialogTabTypes.ALERTS);

  const { getSlackStatus } = useIntegrations();
  const { isExpandedMode } = useExpandedMode();

  const slackStatus = useSelector(selectSlackIntegrationStatus);
  const shouldUpgradeSlack = useSelector(selectSlackUpgradeStatus);
  const withScheduledReports =
    slackStatus === SlackConnectionStatus.Connected && !shouldUpgradeSlack;
  const isTabsShown = withScheduledReports;

  const sidePadding = useGetSidePadding();

  useRunOnce(() => {
    getSlackStatus();
  });

  return (
    <GlobalRenderer>
      <ConfigurationCanvasLeftPanel
        withExpandedModeButton={true}
        sx={{
          gap: isTabsShown ? 1 : undefined,
        }}
      >
        <ConfigurationCanvasPanelHeader withExpandedModeButton={true}>
          Alerts
        </ConfigurationCanvasPanelHeader>
        <MultipleRuleBuildersProvider>
          <ConfigurationCanvasPanelContent
            sx={{
              overflow: 'hidden',
              height: '100%',
              padding: 0, //needed in order to override the existing value (I dont know who needs it)
              display: 'flex',
            }}
          >
            <Stack
              sx={{
                flex: 1,
                overflow: 'hidden',
                gap: isExpandedMode ? 3 : 2,
                '& .MuiTabs-root': {
                  display: isTabsShown ? 'flex' : 'none',
                },
                '.MuiTabs-root': {
                  borderBottom: `1px solid ${colors.grey[120]}`,
                },
              }}
            >
              <Box
                sx={{
                  padding: `0 ${sidePadding}px`,
                }}
              >
                <Tabs
                  value={activeTab}
                  tabs={[
                    {
                      label: AlertsDialogTabTypes.ALERTS,
                      value: AlertsDialogTabTypes.ALERTS,
                    },
                    {
                      label: AlertsDialogTabTypes.SCHEDULED_REPORTS,
                      value: AlertsDialogTabTypes.SCHEDULED_REPORTS,
                    },
                  ]}
                  onChange={(event, tab) => {
                    setActiveTab(tab as AlertsDialogTabTypes);
                  }}
                />
              </Box>
              {activeTab === AlertsDialogTabTypes.ALERTS && <Alerts />}
              {activeTab === AlertsDialogTabTypes.SCHEDULED_REPORTS && <ScheduledReports />}
            </Stack>
          </ConfigurationCanvasPanelContent>
        </MultipleRuleBuildersProvider>
      </ConfigurationCanvasLeftPanel>
    </GlobalRenderer>
  );
};
